import styled from "styled-components";
import InfiniteScroller from 'react-infinite-scroller';

export const BacklinksContainer = styled(InfiniteScroller)`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 20px;
`;
